import clsx from 'clsx'
import React, { FC, useState } from 'react'

import { Loading } from '@Components/CMS/Video'
import { VimeoPlayer } from '@Components/CMS/Video/VimeoPlayer'
import { Asset } from '@Generated/graphql'

import styles from './Video.module.scss'

interface VimeoSetting {
  autoplay: boolean
  loop: boolean
  muted: boolean
}
const vimeoSettings: VimeoSetting = {
  autoplay: true,
  loop: true,
  muted: true,
}

// eslint-disable-next-line @typescript-eslint/member-ordering
export const VimeoHorizontal: FC<{ asset?: Asset, setting?: Partial<VimeoSetting>, isActive: boolean, isFullscreen: boolean }> = ({
  asset,
  isActive,
  isFullscreen = false,
  setting,
}) => {
  const [isLoading, setIsLoading] = useState(true)

  if (!asset) {
    return null
  }

  return (
    <div className={styles.videoRoot}>
      {isLoading && <Loading />}
      <div
        className={clsx(styles.videoContainer, isFullscreen && styles.fullscreen)}
      >
        <VimeoPlayer
          className="grid"
          enableControls={false}
          isVisible={isActive}
          onLoad={setIsLoading}
          options={setting ? { ...vimeoSettings, ...setting } : vimeoSettings}
          showTrendhimControls
          videoID={asset.url}
        />
      </div>
    </div>
  )
}
